import React from 'react';
const regexChatOnline = /agentId>(?<agentId>\d+)\|agentName>(?<agentName>((?!\|).)*)/g;
const sCadenaMsg = "message>";
const sCadenaFinal = "|from>";
const sCadenaInicioWarning = "CHATCOMMAND_cmd>WARNING|warning>";
const sCadenaFinalWarning = "^"


export default class ChatMsgHelper {
  static getMsgResponse = xml => {
    let result = { isWarning: false, message: '' };
    try {
      let message = xml.children[0].children[0].attributes.message.value;

      if (message) {
            if (message.indexOf(sCadenaMsg) > -1) {
              let indice = message.indexOf(sCadenaMsg);
              indice = parseInt(indice) + sCadenaMsg.length;
              result.message = message.substring(indice, message.indexOf(sCadenaFinal));
            }
            else if (message.indexOf(sCadenaInicioWarning) > -1) {
              result.message = message.substring(sCadenaInicioWarning.length, message.indexOf(sCadenaFinalWarning));
              result.isWarning = true;
            }   
      }
    } catch (error) {
      console.log("ChatMsgHelper", error);
    }
    return result;
  };

  static getSessionOnline = xml => {
    let online = xml.all[1].attributes[1].value;
    let result = null;
    if (online) {
      let match = regexChatOnline.exec(online);
      let matchMsg = /welcomeMsg>([^|^]+)/.exec(online);
      if (match) {
        result = { id: match[1], name: match[2],msg: matchMsg[1] };
      }
    }
    return result;
  };

  static getCurrentHour = () => {
    let now = new Date();
    let pm = now.getHours() >= 12;
    let hour12 = now.getHours() % 12;
    if (!hour12) hour12 += 12;
    let minute = now.getMinutes().toString().padStart(2, '0'); 
    return `${hour12}:${minute} ${pm ? "pm" : "am"}`;
  };
  static transformMessage = (reciveMessage) => {
    let array = reciveMessage.split(' ');
    let htmlReturn = [];
    for (let index = 0; index < array.length; index++) {
      if (array[index].includes("https:" || "http:")) {
        htmlReturn.push(<a href={array[index]} target="_blank" rel="noopener noreferrer">{array[index] + " "}</a>);
      }
      else {
        htmlReturn.push(<>{array[index] + " "}</>);
      }
    }
    return htmlReturn;
  }
}
